
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/port.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-basic-port-demo-port-config","docs-tutorial-basic-port-demo-port-prop"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/port.en.md?type=demo')
};